// src/components/ui/HeroSection.js
import React from 'react';
import { Zap, Rocket, Lock } from 'lucide-react';

export default function HeroSection() {
    return (
        <div className="text-center mb-16 animate-fade-in-up">
            <h1 className="text-5xl md:text-6xl font-bold text-[var(--forest-green)] mb-6 font-poppins leading-tight">
                Be First in Line for Your
                <br />
                <span className="text-[var(--forest-green)]"> Dream Job</span>
            </h1>

            <p className="text-lg md:text-xl text-[#4B5563] max-w-3xl mx-auto mb-8 leading-relaxed">
                Store your resume details once and let our Chrome extension automatically
                fill out job applications on JobQue.ai. Don&apos;t be the 153rd applicant -
                be among the first.
            </p>

            {/* Single primary CTA ΓÇô pill-shaped, using the old Get Started color */}
            <div className="flex justify-center mb-12">
                <a
                    href="https://chromewebstore.google.com/detail/jobque-agent/kbbefdejaeljoemfoegfilpjlfolejgk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="primary-cta-button px-10 py-4 bg-[var(--forest-green)] text-white font-semibold text-lg rounded-full hover:bg-[var(--deep-teal)] transition-all shadow-lg hover:shadow-xl transform inline-flex items-center justify-center"
                >
                    Install Extension
                </a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
                {/* Card 1 */}
                <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all transform hover:-translate-y-1">
                    <div className="w-14 h-14 bg-[var(--pale-mint)] rounded-2xl flex items-center justify-center mx-auto mb-4">
                        {/* Icon color now matches navbar green */}
                        <Zap className="w-7 h-7 text-[var(--forest-green)]" />
                    </div>
                    {/* Heading/body colors match JobQue.ai home cards */}
                    <h3 className="text-xl font-bold text-[var(--forest-green)] mb-2 font-poppins">
                        One-Time Setup
                    </h3>
                    <p className="text-[#4B5563] leading-relaxed">
                        Fill out your resume once and we&apos;ll save it securely
                    </p>
                </div>

                {/* Card 2 */}
                <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all transform hover:-translate-y-1">
                    <div className="w-14 h-14 bg-[var(--pale-mint)] rounded-2xl flex items-center justify-center mx-auto mb-4">
                        <Rocket className="w-7 h-7 text-[var(--forest-green)]" />
                    </div>
                    <h3 className="text-xl font-bold text-[var(--forest-green)] mb-2 font-poppins">
                        Instant Autofill
                    </h3>
                    <p className="text-[#4B5563] leading-relaxed">
                        Our extension automatically fills forms on JobQue.ai
                    </p>
                </div>

                {/* Card 3 */}
                <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all transform hover:-translate-y-1">
                    <div className="w-14 h-14 bg-[var(--pale-mint)] rounded-2xl flex items-center justify-center mx-auto mb-4">
                        <Lock className="w-7 h-7 text-[var(--forest-green)]" />
                    </div>
                    <h3 className="text-xl font-bold text-[var(--forest-green)] mb-2 font-poppins">
                        Local Storage
                    </h3>
                    <p className="text-[#4B5563] leading-relaxed">
                        Your data stays in your browser - completely private
                    </p>
                </div>
            </div>
        </div>
    );
}
